import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { useLocation } from 'react-router-dom'
import Sidebar from './Sidebar'
import Share from './Share'
import { hotkeys } from '../config'
import Overview from './Overview'
import Select from './Select'
import Layers from './Layers'
import Screen from './Screen'
import { getState } from '../actions/savedState'
import { setActiveView as setActiveViewConnect, setDialog as setDialogConnect } from '../actions/navigation'
import Map from './Map/Map'

export class SidebarAndMap extends React.Component {
    static propTypes = {
        // redux actions
        setActiveView: PropTypes.func.isRequired,
        setDialog: PropTypes.func.isRequired,
        getState: PropTypes.func.isRequired,
        // redux state
        activeView: PropTypes.string.isRequired,
        // react-router (wrapper)
        path: PropTypes.string.isRequired
    }

    constructor(props) {
        super(props)

        this.state = {
            share: false,
            collapsed: false,
            enableGA: window.SETTINGS.enable_ga
        }
    }

    componentDidMount() {
        const { setDialog, path, getState } = this.props

        window.document.addEventListener('keyup', this.onKeyUp)
        setDialog('disclaimer')

        // Check url for hash and retrieve saved state from db if present
        if (path.startsWith('/s/')) {
            const path_array = path.split('/')
            const hash_input = path_array[path_array.length - 2]
            getState(hash_input)
        }
    }

    /* TODO: This function seems to be left over from an earlier version of SiteCheck and should probably be rewritten.  */
    setActive = active => {
        if (active === 'share') {
            this.setState({ share: true })
            return
        }

        this.setState({
            share: false
        })

        this.props.setActiveView(active)

        this.setCollapsed(false)
        if (this.state.enableGA) {
            this.googleAnalytics(active)
        }
    }

    setCollapsed = collapsed => this.setState({ collapsed })

    onKeyUp = e => {
        const { key, target } = e

        if (['INPUT', 'TEXTAREA'].includes(target.nodeName)) {
            return
        }

        const view = Object.keys(hotkeys.navigation).find(item => hotkeys.navigation[item] === key) || null
        if (view !== null) {
            this.setActive(view)
        }
    }

    googleAnalytics = name => {
        gtag('event', 'click', {
            event_category: 'Navigation',
            event_label: name
        })
    }

    render() {
        const { share, collapsed } = this.state
        const { activeView } = this.props
        const isIE = !!window.document.documentMode

        let view
        switch (activeView) {
            case 'overview':
                view = <Overview />
                break
            case 'analyze':
                view = <Select collapseContent={() => this.setCollapsed(true)} />
                break
            case 'explore':
                view = <Layers />
                break
            case 'screen':
                view = <Screen />
                break
            default:
                view = <Overview />
        }

        return (
            <>
                <div className="columns is-gapless no-margin">
                    <Sidebar
                        active={activeView}
                        share={share}
                        collapsed={collapsed}
                        onMenu={this.setActive}
                        setCollapsed={this.setCollapsed}
                    >
                        {share && <Share className="is-hidden-desktop" />}
                        {view || <div />}
                    </Sidebar>

                    <div className="column" style={{ position: 'relative' }}>
                        {isIE && (
                            <div className="ie-warn">
                                You may experience problems and poor performance using Site Check with{' '}
                                <strong>Internet Explorer</strong>. If this happens, please try using the{' '}
                                <a href="https://www.microsoft.com/en-us/edge">Microsoft Edge</a> web browser.
                            </div>
                        )}
                        <Map active={activeView} />
                    </div>

                    <div id="popupPortal" />
                </div>
            </>
        )
    }
}

const ConnectedSidebarAndMap = connect(
    state => {
        if (!state.navigation) {
            state.navigation = {
                activeView: 'overview',
                dialog: '',
                modalProps: {}
            }
        }
        return { activeView: state.navigation.activeView }
    },
    dispatch => ({
        setActiveView: activeViewName => dispatch(setActiveViewConnect(activeViewName)),
        setDialog: dialogName => dispatch(setDialogConnect(dialogName)),
        getState: hash_input => dispatch(getState(hash_input))
    })
)(SidebarAndMap)

export default props => {
    const path = useLocation().pathname
    return <ConnectedSidebarAndMap path={path} {...props} />
}
